import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzOffer175 } from './pages'

type TIdToPageMapWoofzOffer175 = Record<PageIdWoofzOffer175, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_OFFER1_75: TIdToPageMapWoofzOffer175 = {
  [PageIdWoofzOffer175.SUBSCRIPTIONS_OFFER1_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_75/pages/subscriptions/SubscriptionsOffer175'
      ).then((m) => ({
        default: m.SubscriptionsOffer175,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_75/pages/subscriptions/SubscriptionsOffer175'
      ),
  },
  [PageIdWoofzOffer175.CHAT_UPSELL_OFFER1_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_75/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_75/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageIdWoofzOffer175.UPSELL_OFFER1_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_75/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_offer/woofz_offer1_75/pages/upsell/Upsell'),
  },
  [PageIdWoofzOffer175.DOWNLOAD_OFFER1_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_75/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_75/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzOffer175.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
